import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=10957ce5&"
import script from "./AdminUsers.vue?vue&type=script&lang=js&"
export * from "./AdminUsers.vue?vue&type=script&lang=js&"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=10957ce5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports